import React, { useEffect, useState } from 'react';
import * as Request from '../../common/request';
import { List, Dialog } from 'antd-mobile'

const PageModel = props => {
	const [list, setList] = useState([]);

	const getList = async () => {
		const result = await Request.get({
			url: '/company/list'
		});
		if (!result) return;

		const list = result.data.list || [];
		setList(list);
	};
	
	useEffect(() => {
		//获取企业列表
		getList()
	}, [123]);

	const postdata = (item) => {
		console.log(item);
		window.localStorage.setItem('companyId', item.id);

		window.history.back(-1);
	}

	return (
		<List header='所有企业列表'>
			{list.length > 0 && list.map((item, index) => {
				return (
					<List.Item  key={index} onClick={() => {	
						postdata(item)
					}}>{item.companyName}</List.Item>
				)
			})
			}

		</List>
	);
};

export default PageModel;
